<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="类型名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入类型名称" v-trim maxlength="50"/>
      </el-form-item>
      <el-form-item label="类型变量" prop="variable" required>
        <el-input v-model="form.variable" placeholder="请输入类型变量" v-trim maxlength="50"/>
      </el-form-item>
      <el-form-item label="参数获取方式" prop="getType" required>
        <el-select v-model="form.getType" placeholder="请选择参数获取方式">
          <el-option value="S" label="随机获取一条"/>
          <el-option value="M" label="随机获取多条"/>
        </el-select>
      </el-form-item>
      <el-form-item label="作用域" prop="variable" required>
        <el-select v-model="form.scope" placeholder="请选择作用域">
          <el-option value="TEMPLATE" label="模版"/>
          <el-option value="MODULE" label="模块"/>
        </el-select>
      </el-form-item>
      <el-form-item label="类型字段配置" prop="fieldConfig" required>
        <ul>
          <li><el-button type="primary" size="mini" @click="addFieldRow">添加行</el-button></li>
        </ul>
        <el-table
          :data="fields"
          stripe
        >
          <el-table-column prop="variable" label="字段变量" min-width="100px">
            <el-input slot-scope="{row}" placeholder="请输入字段变量" v-model="row.variable" v-trim/>
          </el-table-column>
          <el-table-column prop="name" label="字段名称" min-width="100px">
            <el-input slot-scope="{row}" placeholder="请输入字段名称" v-model="row.name" v-trim/>
          </el-table-column>
          <el-table-column
            label="操作"
            min-width="80"
            fixed="right"
          >
            <template slot-scope="{$index}">
              <el-button type="text" @click="deleteField($index)" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaParameterTypeWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  props: {
    template: {
      required: true
    }
  },
  data () {
    const _this = this
    return {
      form: {
        id: null,
        name: '',
        variable: '',
        scope: 'TEMPLATE',
        getType: '',
        fieldConfig: ''
      },
      fields: [],
      rules: {
        name: [
          { required: true, message: '请输入类型名称' }
        ],
        variable: [
          { required: true, message: '请输入类型变量' },
          { validator: _this.checkEnName }
        ],
        fieldConfig: [
          { required: true, message: '请添加类型字段配置' }
        ]
      }
    }
  },
  watch: {
    fields () {
      this.form.fieldConfig = JSON.stringify(this.fields)
    }
  },
  methods: {
    // 验证模块英文名称
    checkEnName (rule, value, callback) {
      if (value.length < 3) {
        callback(new Error('变量名称必须大于2个字符'))
        return
      }
      if (!/^[a-z]+[a-zA-Z0-9]+$/.test(value)) {
        callback(new Error('变量名称必须为字母或数字，且必须以小写字母开头'))
        return
      }
      callback()
    },
    /**
     * 打开窗口
     */
    open (title, target) {
      this.title = title
      this.visible = true
      this.fields = []
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.fields = JSON.parse(this.form.fieldConfig)
      })
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      if (!this.__check()) {
        return
      }
      this.form.fieldConfig = JSON.stringify(this.fields)
      this.form.templateId = this.template.id
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate()
        return
      }
      this.__confirmEdit()
    },
    // 添加字段行
    addFieldRow () {
      this.fields.push({
        variable: '',
        name: ''
      })
    },
    // 删除字段行
    deleteField (index) {
      const field = this.fields[index]
      if (field.name.trim() === '' && field.variable.trim() === '') {
        this.fields.splice(index, 1)
        return
      }
      this.$dialog.deleteConfirm(`确认删除【${field.name}】字段配置吗`)
        .then(() => {
          this.fields.splice(index, 1)
        })
        .catch(() => {})
    },
    // 新建&编辑验证
    __check () {
      // 验证字段变量名必填
      if (this.fields.filter(f => f.variable.trim() === '').length > 0) {
        this.$tip.warning('存在字段变量名未填写')
        return false
      }
      // 验证字段名称必填
      if (this.fields.filter(f => f.name.trim() === '').length > 0) {
        this.$tip.warning('存在字段名称未填写')
        return false
      }
      // 验证字段变量名格式
      for (const field of this.fields) {
        if (!this.__checkVariable(field.variable)) {
          return false
        }
      }
      // 验证字段变量是否重复
      return true
    },
    // 验证模块英文名称
    __checkVariable (value) {
      if (!/^[a-z]+[a-zA-Z0-9_]+$/.test(value)) {
        this.$tip.warning('字段变量名格式不正确，字段变量名必须为小写字母，特殊字符仅允许使用"_"，且必须以小写字母开头')
        return false
      }
      return true
    }
  },
  created () {
    this.config({
      api: '/template/parameterType'
    })
  }
}
</script>

<style scoped>

</style>
